// Debug Authentication Utility
// Add this to your browser console to debug auth issues

import {
  getAccessToken,
  getIdToken,
  getCurrentSession,
} from '../services/authService';

export const debugAuth = async () => {
  console.group('🔍 Authentication Debug');

  try {
    console.log('📍 API URL:', process.env.REACT_APP_API_URL);
    console.log('🏊 User Pool ID:', process.env.REACT_APP_USER_POOL_ID);
    console.log('🆔 Client ID:', process.env.REACT_APP_USER_POOL_CLIENT_ID);
    console.log('');

    // Get session
    console.log('Getting session...');
    const session = await getCurrentSession();

    if (!session) {
      console.error('❌ No session found - user is not authenticated');
      console.groupEnd();
      return;
    }

    console.log('✅ Session found');
    console.log('   Valid:', session.isValid());
    console.log('');

    // Get access token
    console.log('Getting access token...');
    const accessToken = await getAccessToken();

    if (!accessToken) {
      console.error('❌ No access token');
      console.groupEnd();
      return;
    }

    console.log('✅ Access token retrieved');
    console.log('   Preview:', accessToken.substring(0, 40) + '...');
    console.log('   Length:', accessToken.length);
    console.log('');

    // Decode access token
    try {
      const parts = accessToken.split('.');
      if (parts.length === 3) {
        const payload = JSON.parse(atob(parts[1]));
        console.log('📦 Access Token Payload:');
        console.log(
          '   token_use:',
          payload.token_use,
          payload.token_use === 'access' ? '✅' : '❌ WRONG!'
        );
        console.log('   sub:', payload.sub);
        console.log('   username:', payload.username);
        console.log('   client_id:', payload.client_id);
        console.log('   iss:', payload.iss);
        console.log('   exp:', new Date(payload.exp * 1000).toISOString());
        console.log('   iat:', new Date(payload.iat * 1000).toISOString());
        console.log(
          '   Expired:',
          payload.exp * 1000 < Date.now() ? '❌ YES' : '✅ NO'
        );
        console.log('');
      }
    } catch (e) {
      console.error('❌ Error decoding access token:', e);
    }

    // Get ID token for comparison
    console.log('Getting ID token...');
    const idToken = await getIdToken();

    if (idToken) {
      console.log('✅ ID token retrieved');
      console.log('   Preview:', idToken.substring(0, 40) + '...');
      console.log('');

      // Decode ID token
      try {
        const parts = idToken.split('.');
        if (parts.length === 3) {
          const payload = JSON.parse(atob(parts[1]));
          console.log('📦 ID Token Payload:');
          console.log('   token_use:', payload.token_use || 'id');
          console.log('   sub:', payload.sub);
          console.log('   email:', payload.email);
          console.log('   cognito:username:', payload['cognito:username']);
          console.log('');
        }
      } catch (e) {
        console.error('❌ Error decoding ID token:', e);
      }
    }

    // Test API call
    console.log('🌐 Testing API call...');
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/ownership`;
    console.log('   URL:', apiUrl);
    console.log('   Sending request...');

    const response = await fetch(apiUrl, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });

    console.log('📡 API Response:');
    console.log('   Status:', response.status, response.ok ? '✅' : '❌');
    console.log('   Status Text:', response.statusText);
    console.log('');

    if (response.ok) {
      const data = await response.json();
      console.log('✅ API call successful!');
      console.log('   Data:', data);
    } else {
      const errorText = await response.text();
      console.error('❌ API call failed!');
      console.error('   Error:', errorText);

      try {
        const errorJson = JSON.parse(errorText);
        console.error('   Error details:', errorJson);
      } catch (e) {
        // Error is not JSON
      }
    }
  } catch (error: any) {
    console.error('❌ Debug Error:', error.message);
    console.error('   Stack:', error.stack);
  }

  console.groupEnd();
};

// Make it available globally
if (typeof window !== 'undefined') {
  (window as any).debugAuth = debugAuth;
  console.log('✅ debugAuth() function is now available in the console');
}

export default debugAuth;
